<template>
<div :class="$style.receiveToast">
  <div :class="$style.mask"></div>
  <div :class="$style.content">
    <div v-if="!step" :class="$style.step_0">
      <img :src="`${$cdnLink}/red-envelope/red_back.png`" alt="" :class="$style.back">
      <img :src="`${$cdnLink}/red-envelope/open.png`" alt="" :class="$style.btn" @click="$emit('receive')">
    </div>
    <div v-else :class="$style.step_1">
      <img :src="`${$cdnLink}/red-envelope/red_back1.png`" alt="" :class="$style.back">
      <div :class="$style.text">
        <p>恭喜您获得</p>
        <p>{{money}}元现金红包</p>
        <p>请到我的钱包中查看</p>
      </div>
      <button @click="$emit('openWallet')" :class="$style.primary">我的钱包</button>
      <i :src="`${$cdnLink}/red-envelope/close.png`" @click="$emit('close')" :class="[$style.close, 'iconfont', 'yw-guanbi1']" />   
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: '',
  props: ['money', 'step'],
  data () {
    return {
    };
  }
}
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

.receiveToast {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 1;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;  
    z-index: 2;
    background: rgba(0, 0, 0, 0.6);
  }
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 160px;
    height: 280px;
    overflow: auto;
    z-index: 3;
    font-size: 0;
    .step_0, .step_1 {
      position: relative;
      height: 240px;
      > img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        margin: auto;
      }
    }
    .step_0 {
      .btn {
        width: 80px;
        height: 80px;
        margin: auto;
        animation-name: scaleDraw; 
        animation-timing-function: ease-in-out; 
        animation-iteration-count: infinite;
        animation-duration: 2s;
      }
    }
    .step_1 {
      position: relative;
      height: 220px;
      .text {
        position: absolute;
        font-size: 12px;
        color: #943229;
        text-align: center;
        top: 70px;
        width: 100%;
        line-height: 20px;
        > p:nth-child(2) {
          font-weight: bold;
          font-size: 14px;
        }
        > p:nth-child(3) {
          margin-top: 10px;
        }
      }
      .primary {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
        height: 32px;
        background: linear-gradient(270deg, #FFDD99, #FFEEBB, #FFEECC);
        box-shadow: 0 2px 7px 0 rgba(188, 40, 29, 0.43);
        border-radius: 19px;
        border: none;
        outline: none;
        color: #D06747;
        font-size: 12px;
      }
      .close {
        position: absolute;
        bottom: -38px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 25px;
        color: #FFFFFF;
      }
    }
  }
}
</style>